module.exports = __webpack_public_path__ + "src/assets/games/56/3.png";